import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
    return {
        drawer: {
            flexShrink: 0
        },
        drawerPaper: {
            width: "780px",
            height: "calc(100% - 24px) !important",
            marginTop: "12px",
            boxShadow: "-20px 20px 30px 0 rgba(0, 0, 0, 0.2)",
            borderRadius: "16px 0 0 16px",
        },
        header: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            padding: theme.spacing(0.5, 4),
        },
        body: {
            position: "relative",
            padding: theme.spacing(4),
            overflowY: "auto",
            height: "calc(100% - 48px)",
            overflowX: "hidden",
        },
    };
});
